import React from 'react';
import './TasksCompleted.css';
import { ReactComponent as ChartIcon } from '../../icons/TasksCompleted.svg';

function TasksCompleted({ tasksCompleted, completionPercentage }) {
    return (
        <div className='tasks-card'>
            <h3>
                <ChartIcon className="header-emoji"/>
                <span className="header-text">Задач решено</span>
            </h3>
            <div className="tasks-main-content">
                <p className="tasks-number"><strong>{tasksCompleted}</strong></p>
                <div className="tasks-percentage">
                    <span>{completionPercentage}%</span> всего набора
                </div>
            </div>
        </div>
    );
}

export default TasksCompleted;
